import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import AppStorage from "@/appStorage";
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import VueMeta from "vue-meta";
// install rules and localization
Object.keys(rules).forEach((rule) => {
  // @ts-ignore
  extend(rule, rules[rule]);
});

localize("sv", {
  messages: {
    alpha: "Fältet {_field_} får bara innehålla alfabetiska tecken",
    alpha_dash: "Fältet {_field_} får bara innehålla alfanumeriska tecken såväl som snedstreck och understreck",
    alpha_num: "Fältet {_field_} får bara innehålla alfanumeriska tecken",
    alpha_spaces: "Fältet {_field_} får bara innehålla alfabetiska tecken och mellanslag",
    between: "Fältet {_field_} måste vara mellan {min} och {max}",
    confirmed: "Fältet {_field_} matchar inte {target}",
    digits: "Fältet {_field_} måste vara numeriskt och innehålla exakt {length} siffor",
    dimensions: "Fältet {_field_} måste vara {width} pixlar bred och {height} pixlar hög",
    email: "Fältet {_field_} måste vara en giltig e-postadress",
    excluded: "Fältet {_field_} måste vara ett godkänt alternativ",
    ext: "Fältet {_field_} måste vara en godkänd fil",
    image: "Fältet {_field_} måste vara en bildfil",
    integer: "Fältet {_field_} måste vara ett heltal",
    length: "Fältet {_field_} måste vara {length} långt",
    oneOf: "Fältet {_field_} måste vara ett godkänt alternativ",
    max: "Fältet {_field_} får inte vara längre än {length} tecken",
    mimes: "Fältet {_field_} måste ha en filändelse",
    min: "Fältet {_field_} måste minst vara {length} tecken",
    numeric: "Fältet {_field_} får bara innehålla numeriska tecken",
    regex: "Fältet {_field_} har en felaktig formatering",
    required: "Fältet {_field_} är obligatoriskt",
    required_if: "Fältet {_field_} är obligatoriskt",
    size: "Fältet {_field_} måste vara mindre än {size}KB",
    double: "Fältet {_field_} måste vara ett giltigt decimal",
  },
});
Vue.config.productionTip = false;
Vue.AppStorage = new AppStorage();
Vue.prototype.AppStorage = Vue.AppStorage;
Vue.IsProduction = process.env.NODE_ENV === "production";
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.use(VueMeta);
export enum StorageKeys {
  Authenticated = "authenticated",
  GolfId = "golf-id",
}

export enum ContentPageId {
  Home = "2jPNb9QSFqJYZxgPwcC0IM",
  Login = "5fd3D9VQGFNay8t6tKkzF9",
}

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
